import React, {memo} from 'react';
import Tel from '../../Tel/Tel';

export default memo(() => {
    return <Tel test_id="tel_2" number="02-2738-2131"/>;
});
